var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#252525","transform":"translate(1 1)"},[React.createElement("circle",{"cx":"4.667","cy":"4.667","r":"4.667","strokeWidth":"1.75","key":0}),React.createElement("path",{"strokeWidth":"1.167","d":"M8.438 8.679l.825-.825 3.3 3.3-.825.825z","key":1})]));
}

Search.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = Search;

Search.default = Search;
